module.exports = __webpack_public_path__ + "img/image_home_01.dceb2e71.svg";